export default __webpack_public_path__ + "static/media/esg-73.8f2263a4.jpg";